<h3 class="attachments-header"><mat-icon class="custom-mat-icon-1">attach_file</mat-icon> Chart Attachments</h3>
<mat-list class="attachments" dense>
  <ng-container *ngIf="attachments?.length; else empty">
    <ng-container *ngFor="let attachment of attachments; trackBy: trackById">
      <mat-list-item>
        <div class="attachment">
          <button
            data-testid="attachment-name"
            class="attachment-name"
            [matTooltip]="downloadDisabled ? '' : attachment.data.fileName"
            (click)="onDownload(attachment)"
            mat-button
            color="primary"
            [disabled]="!!downloadDisabled"
          >
            {{ attachment.data.fileName }}
          </button>
          <button
            [disabled]="!!deleteDisabled"
            data-testid="delete-attachment"
            class="attachment-delete custom-mat-icon-button-1rem"
            mat-icon-button
            (click)="onDelete(attachment)"
          >
            <mat-icon>cancel</mat-icon>
          </button>
        </div>
      </mat-list-item>
    </ng-container>
  </ng-container>

  <ng-template #empty>
    <mat-list-item>No chart attachments available.</mat-list-item>
  </ng-template>
</mat-list>
